import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Alert } from "@mui/material";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { TextField } from "@mui/material";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

export default function NewMailSetting(props) {
  const [errors, setErrors] = React.useState({
    minLengthError: "",
    regexError: "",
    confirmationError: "",
    mailExistsError: "",
  });

  const { setGlobalMessage } = React.useContext(GlobalMessageContext);

  const [saveDisabled, setSaveDisabled] = React.useState(true);
  const [mail, setMail] = React.useState("");
  const mailAll = false;
  const mailFailed = false;

  const clearForm = () => {
    setMail("");
    setErrors({
      minLengthError: "",
      regexError: "",
      confirmationError: "",
      mailExistsError: "",
    });
  };

  useEffect(() => {
    if (!(mail === "")) {
      setSaveDisabled(false);
    } else {
      setSaveDisabled(true);
    }
  }, [mail]);

  const handleSubmitMailSetting = (e) => {
    const formData = { mail, mailAll, mailFailed };

    e.preventDefault();
    setSaveDisabled(true);

    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/settingMail/add",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(formData),
      }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Unable to access endpoint: settingMail/add");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data === -1) {
          setErrors({ mailExistsError: "Die Mail ist bereits vergeben." });
        } else {
          clearForm();
          props.setRows((prev) => prev.concat([{ mail: mail, id: data }]));
        }
        setGlobalMessage({
          globalMessage: "E-Mail angelegt",
          severity: "success",
        });
      })
      .catch((error) => {
        setGlobalMessage({
          globalMessage: "Vorgang fehlgeschlagen",
          severity: "error",
        });
      })
      .finally(() => setSaveDisabled(false));
  };

  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)}>
      <Box component="form" onSubmit={(e) => handleSubmitMailSetting(e)}>
        <DialogTitle>Neue E-Mail anlegen</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="newUserMail"
            label="E-Mail Adresse"
            type="email"
            fullWidth
            variant="standard"
            required
            value={mail}
            onInput={(e) => {
              setMail(e.target.value);
            }}
          />

          {(errors.minLengthError ||
            errors.regexError ||
            errors.confirmationError ||
            errors.userExistsError) && (
            <Alert sx={{ mt: 3 }} variant="outlined" severity="error">
              <ul style={{ margin: 0 }}>
                {errors.minLengthError && (
                  <li key="minLengthError">{errors.minLengthError}</li>
                )}
                {errors.regexError && (
                  <li key="regexError">{errors.regexError}</li>
                )}
                {errors.confirmationError && (
                  <li key="confirmationError">{errors.confirmationError}</li>
                )}
                {errors.mailExistsError && (
                  <li key="userExistsError">{errors.userExistsError}</li>
                )}
              </ul>
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.setOpen(false)}>Schließen</Button>
          <Button onClick={() => clearForm()}>Formular leeren</Button>
          <Button type="submit" disabled={saveDisabled}>
            Hinzufügen
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
